import { render, staticRenderFns } from "./forget-form.vue?vue&type=template&id=7d7b29fa&scoped=true&"
import script from "./forget-form.vue?vue&type=script&lang=js&"
export * from "./forget-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7b29fa",
  null
  
)

export default component.exports